/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type signup_viewer = {
    readonly actualPersonId: string | null;
    readonly downForMaintenance: boolean | null;
    readonly " $refType": "signup_viewer";
};
export type signup_viewer$data = signup_viewer;
export type signup_viewer$key = {
    readonly " $data"?: signup_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"signup_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "signup_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downForMaintenance",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '3104530ab4abc48f4cd52856b3827a78';
export default node;
